export default __webpack_public_path__ + "b1aded5817acdd5c9289c8e7b3b3af7d.svg";